import React from 'react'
import { NavLink } from 'react-router-dom';
// import icon from '../icon.png'
import talk from '../../../images/home_images/talk.png'
import food from '../../../images/home_images/food.png'
import book from '../../../images/home_images/book.png'
import TestimonialHome from './TestimonialHome';
import partner01 from '../../../images/home_images/partner01.png';
import partner02 from '../../../images/home_images/partner02.png';
function Offering() {
    return (
        <div>
            <section className='offering-section '>
                <div className="container">
                    <div className="offerings">
                        <h1 className='custom text-center' data-aos="fade-down" data-aos-duration="3000">
                            {/* <img src={icon} alt="" style={{ height: '52px', width: '65px', marginRight: '20px' }} /> */}
                            Our Offerings
                        </h1>
                        <h4 className='text-center fw-bold offering-title'data-aos="fade-down" data-aos-duration="3000">Anuyog empowers you to live a nature-inspired, healthy lifestyle through three core pillars</h4>
                        <div className="all_offers" data-aos="zoom-in" data-aos-duration="1000">
                            <NavLink
                                to="/consultancy"
                                className={({ isActive }) => (isActive ? 'main-active' : '')}
                                onClick={() => {
                                    window.scrollTo(0, 0);
                                }}
                            >
                                <div className="offers">

                                    <div className="offering-icon">
                                        <img src={talk} alt="" />
                                    </div>
                                    <div className="offering-text">
                                        <h4 className='fw-bold'> Consultancy</h4>
                                        <p > Personalized guidance on Diet, Healing, Yoga, Organic produce & Healthy living space </p>
                                    </div>

                                </div>
                            </NavLink>

                            <NavLink
                                to="/product"
                                className={({ isActive }) => (isActive ? 'main-active' : '')}
                                onClick={() => {
                                    window.scrollTo(0, 0);
                                }}
                            >
                                <div className="offers">

                                    <div className="offering-icon">
                                        <img src={food} alt="" />
                                    </div>
                                    <div className="offering-text">
                                        <h4 className='fw-bold'> Products </h4>
                                        <p >Carefully chosen products to support your journey toward
                                            sustainable well being
                                        </p>
                                    </div>
                                </div>
                            </NavLink>


                            <NavLink
                                to="/institute"
                                className={({ isActive }) => (isActive ? 'main-active' : '')}
                                onClick={() => {
                                    window.scrollTo(0, 0);
                                }}
                            >
                                <div className="offers">

                                    <div className="offering-icon">
                                        <img src={book} alt="" />
                                    </div>
                                    <div className="offering-text">
                                        <h4 className='fw-bold'> Institute</h4>
                                        <p>Education and awareness that enable you to make conscious choices for healthy living. </p>
                                    </div>

                                </div>
                            </NavLink>



                        </div>
                        <div className="how">
                            <NavLink
                                to="/contact"
                                onClick={() => {
                                    window.scrollTo(0, 0);
                                }}
                            >
                                <button type="button" className="btn">Book a Free Discovery Call</button>
                            </NavLink>
                        </div>
                    </div>
                </div>
            </section>

            <section className='pillar-section'>
                <div className="container">
                    <div className="pillar">
                        <h2 className='mb-4'data-aos="fade-down" data-aos-duration="3000"><strong style={{ color: '#9D3B24' }}>Our Values</strong></h2>
                        <h4 className='fw-bold mb-5 offering-title'data-aos="fade-down" data-aos-duration="3000">Our values are the guiding light, keeping us true to our mission and purpose.</h4>
                    </div>
                    <div className="all-pillar">
                        <div className="pillar-detail">
                            <div className="pillar-image">

                                <img src='/images/affordable.png' alt="" />
                            </div>
                            <div className="pillar-text">
                                <h5 className='fw-bold'>Affordable</h5>
                                <h6 className='fw-bold'>Wellness for every budget</h6>
                            </div>
                        </div>

                        <div className="pillar-detail">
                            <div className="pillar-image">
                                <div>
                                    <img src='/images/support.png' alt="" />
                                </div>
                            </div>
                            <div className="pillar-text">
                            <h5 className='fw-bold'>Accessible</h5>
                            <h6 className='fw-bold'>Easily available with support</h6>
                            </div>
                        </div>
                        <div className="pillar-detail">
                            <div className="pillar-image">

                                <img src='./images/embracing.png' alt="" />

                            </div>
                            <div className="pillar-text">
                            <h5 className='fw-bold'>Anekantvad</h5>
                            <h6 className='fw-bold'>Embracing all perspectives</h6>
                            </div>
                        </div>
                        <div className="pillar-detail">
                            <div className="pillar-image">
                                <div>
                                    <img src='./images/thoughtfull.png' alt="" />
                                </div>
                            </div>
                            <div className="pillar-text">
                            <h5 className='fw-bold'>Syadvad</h5>
                            <h6 className='fw-bold'>Thoughtful and contextual guidance</h6>
                            </div>
                        </div>
                        <div className="pillar-detail">
                            <div className="pillar-image">
                                <img src='./images/peace.png' alt="" />
                            </div>
                            <div className="pillar-text">
                            <h5 className='fw-bold'>Ahinsak</h5>
                            <h6 className='fw-bold'>Compassionate and non-violent living</h6>
                            </div>
                        </div>
                    </div>
                </div>

            </section>

            <section className='partners-section'>
                  <div className="container">
                    <div className="partners">
                    <div className="pillar">
                        <h2 className='mb-4'data-aos="fade-down" data-aos-duration="3000"><strong style={{ color: '#9D3B24' }}>Our Partners</strong></h2>
                        <h4 className='fw-bold mb-5 offering-title'data-aos="fade-down" data-aos-duration="3000">Collaboration fuels our mission, making it accessible and impactful</h4>
                    </div>
                    <div className="partner-images">
                        <img src={partner01} alt="Banyan roots" />
                        <a href="https://efsouls.com/" target='_blank' rel='noreferrer'>
                          <img src={partner02} alt="EFSOULS" />
                        </a>
                    </div>
                    </div>
                  </div>
            </section>

            <TestimonialHome/>
        </div>
    )
}

export default Offering
